const steps = [
  { no: '01', title: '需求訪談', phase: 'Discovery', icon: 'ri-chat-smile-3-line', duration: '1–2 週' },
  { no: '02', title: '現場丈量', phase: 'Survey', icon: 'ri-ruler-2-line', duration: '1 週' },
  { no: '03', title: '概念提案', phase: 'Concept', icon: 'ri-draft-line', duration: '2–3 週' },
  { no: '04', title: '設計深化', phase: 'Development', icon: 'ri-pencil-ruler-2-line', duration: '3–5 週' },
  { no: '05', title: '工程施作', phase: 'Construction', icon: 'ri-tools-line', duration: '依規模' },
  { no: '06', title: '完工交付', phase: 'Handover', icon: 'ri-checkbox-circle-line', duration: '1 週' },
];

export default function ProcessOverview() {
  return (
    <section className="py-16 md:py-20 bg-[#1a1a1a]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 mb-12">
          <div>
            <p className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase mb-3">Process Overview</p>
            <h2
              className="font-bold text-white leading-[1.35]"
              style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)' }}
            >
              六大階段總覽
            </h2>
          </div>
          <p className="text-white/55 max-w-md" style={{ fontSize: '1rem' }}>
            每個階段環環相扣，確保商業空間設計從策略規劃到工程落地，步步精準。
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connector Line */}
          <div className="hidden lg:block absolute top-[52px] left-[8.33%] right-[8.33%] h-px bg-[#b8956a]/30 z-0"></div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 lg:gap-4 relative z-10">
            {steps.map((s, i) => (
              <div key={i} className="flex flex-col items-center text-center">
                {/* Icon Circle */}
                <div className="w-[72px] h-[72px] flex items-center justify-center bg-[#b8956a]/15 border border-[#b8956a]/40 rounded-full mb-4 relative">
                  <i className={`${s.icon} text-[#b8956a] text-2xl`}></i>
                  {/* Step Number */}
                  <div className="absolute -top-1.5 -right-1.5 w-6 h-6 flex items-center justify-center bg-[#b8956a] rounded-full">
                    <span className="text-white text-[10px] font-bold">{s.no}</span>
                  </div>
                </div>
                <p className="text-xs text-[#b8956a] uppercase tracking-wider mb-1 font-medium">{s.phase}</p>
                <h4 className="text-white font-semibold text-sm mb-2">{s.title}</h4>
                <span className="text-white/40 text-xs px-3 py-1 bg-white/5 rounded-full">{s.duration}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Note */}
        <div className="mt-14 pt-10 border-t border-white/10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: 'ri-user-settings-line', title: '1 對 1 專屬顧問', desc: '每個案子均指派專屬設計顧問，全程負責溝通與品質確認。' },
            { icon: 'ri-notification-4-line', title: '定期主動回報', desc: '施工期間每週主動提供進度報告，業主不需要一直追問進度。' },
            { icon: 'ri-money-dollar-circle-line', title: '費用透明不超支', desc: '工程預算細項於設計深化階段完整列明，避免施工中出現追加。' },
          ].map((item) => (
            <div key={item.title} className="flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#b8956a]/15 rounded-xl flex-shrink-0">
                <i className={`${item.icon} text-[#b8956a] text-lg`}></i>
              </div>
              <div>
                <h4 className="text-white font-semibold text-sm mb-1.5">{item.title}</h4>
                <p className="text-white/50 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
